import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV, waLink } from "@/lib/brand";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 relative flex items-center justify-between lg:justify-between">
        <a
          href="#inicio"
          data-testid="header-logo"
          className="group lg:static absolute left-1/2 -translate-x-1/2 lg:left-auto lg:translate-x-0 flex items-center"
        >
          <img
            src={BRAND.logo_url}
            alt="ATL Esquadrias"
            className="h-16 w-16 sm:h-20 sm:w-20 lg:h-20 lg:w-20 object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8 mx-auto">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.replace("#", "")}`}
              className="text-[12px] uppercase tracking-[0.22em] text-zinc-300 hover:text-[#facc15] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Spacer on mobile to keep flex balanced when logo is absolutely centered */}
        <div className="lg:hidden w-10" aria-hidden />

        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="hidden md:inline-flex items-center gap-2 px-5 py-3 bg-[#facc15] text-black font-bold uppercase text-[11px] tracking-[0.22em] hover:bg-white transition-colors"
          >
            Orçamento
            <span aria-hidden>→</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-white"
            aria-label="Abrir menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl"
        >
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.href.replace("#", "")}`}
                className="text-sm uppercase tracking-[0.22em] text-zinc-200 hover:text-[#facc15]"
              >
                {item.label}
              </a>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-btn"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-4 bg-[#facc15] text-black font-bold uppercase text-[11px] tracking-[0.22em]"
            >
              Solicitar Orçamento
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
